<template lang='pug' src='./Hero.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// Hero.vue?1014ed3d